/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Col,
  Form,
  Input,
  Row,
} from 'antd';
import Table from 'components/Table';
import { checkToken } from 'api/utils';
import { formatReceived } from 'utils/formatValues';
import { getModelPermission } from 'utils/permission';
import { getHistoricoVacacionesEmpleados } from 'api/nominas/historicoVacaciones';
import { getVacacionesEmpleadosDiasDisfrutados } from 'api/nominas/vacaciones/vacacionesEmpleadosDiasDisfrutados';

export const HistoricoVacacionesEmpleadosPermission = {
  permissionModel: 'historicovacacionempleado',
  catalogsModel: [],
  tabsModels: [],
};

const ExpedienteVacaciones = ({
  currentEmpleado,
  datosOperacionales,
}) => {
  const [form] = Form.useForm();
  const [data, setData] = useState([]);

  const getPermission = getModelPermission(
    HistoricoVacacionesEmpleadosPermission.permissionModel,
    HistoricoVacacionesEmpleadosPermission.catalogsModel,
    HistoricoVacacionesEmpleadosPermission.tabsModels,
    false,
  );

  useEffect(() => {
    form.resetFields();
    let mounted = true;
    const fetchAll = async () => {
      await checkToken();
      const [
        _vacacionesDisfrutadas,
        _data,
      ] = await Promise.all([
        getVacacionesEmpleadosDiasDisfrutados({ empleado: currentEmpleado }),
        getHistoricoVacacionesEmpleados({ empleado: currentEmpleado }),
      ]);
      if (mounted) {
        const historicoData = formatReceived(_data);
        setData(historicoData);

        const _vacacionesEmpleadosPeriodosEmpleado = _vacacionesDisfrutadas.find((e) => e.empleado === currentEmpleado);

        // 1. Aseguramos que los días con derecho sean un número (por defecto 0)
        const diasConDerecho = Number(_vacacionesEmpleadosPeriodosEmpleado?.dias_con_derecho) || 0;

        // 2. Sumamos todos los días disfrutados que vienen en el historial (_data)
        const totalDiasDisfrutados = historicoData.reduce((acumulador, registro) => acumulador + (Number(registro.dias_habiles_disfrutados) || 0), 0);

        // 3. Calculamos los días pendientes dinámicamente
        const diasPendientes = diasConDerecho - totalDiasDisfrutados;

        // 4. Actualizamos el formulario con los valores correctos
        form.setFieldsValue({
          dias_con_derecho: diasConDerecho.toString(),
          dias_disfrutados: totalDiasDisfrutados.toString(),
          dias_pendientes: diasPendientes.toString(),
        });
      }
    };
    if (currentEmpleado) {
      fetchAll();
    } else {
      setData([]);
    }
    return () => { mounted = false; };
  }, [currentEmpleado]);

  const calcularAntiguedad = (fechaCaptura) => {
    // eslint-disable-next-line no-unsafe-optional-chaining
    const fechaDiferencia = fechaCaptura - datosOperacionales?.fecha_de_alta;
    const fechaNueva = new Date(fechaDiferencia);
    const fechaAnual = (fechaNueva.getUTCFullYear() - 1970);
    const fechaMes = (fechaNueva.getUTCMonth());
    if ((Math.sign(fechaAnual) === -1) || (Number.isNaN(fechaAnual))) {
      return 0;
    }
    return `${fechaAnual} ${(fechaAnual === 1 ? 'año' : 'años')} ${fechaMes} ${(fechaMes === 1 ? 'mes' : 'meses')}`;
  };

  const columns = [
    {
      titleText: 'Fecha Ejecución',
      dataIndex: 'fecha_captura',
      key: 'fecha_ejecucion',
      width: 200,
      render: (val) => val?.format('DD/MM/YYYY'),
    },
    {
      titleText: 'Antigüedad',
      dataIndex: 'fecha_captura',
      key: 'antiguedad',
      width: 200,
      render: (val) => calcularAntiguedad(val),
    },
    {
      titleText: 'Año',
      dataIndex: 'ano',
      key: 'ano',
      width: 200,
    },
    {
      titleText: 'Periodo',
      dataIndex: 'periodo',
      key: 'periodo',
      width: 200,
    },
    {
      titleText: 'Fecha Inicial',
      dataIndex: 'fecha_inicial',
      key: 'periodo',
      width: 200,
      render: (val) => val?.format('DD/MM/YYYY'),
    },
    {
      titleText: 'Fecha Final',
      dataIndex: 'fecha_final',
      key: 'fecha_final',
      width: 200,
      render: (val) => val?.format('DD/MM/YYYY'),
    },
    {
      titleText: 'Días Hábiles Disfrutados',
      dataIndex: 'dias_habiles_disfrutados',
      key: 'dias_habiles_disfrutados',
      width: 250,
    },
    {
      titleText: 'Observaciones',
      dataIndex: 'observaciones',
      key: 'observaciones',
      width: 400,
    },
  ];

  return (
    <>
      <Form
        layout="vertical"
        form={form}
        scrollToFirstError
        name="general"
        disabled
      >
        <Row gutter={10}>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="dias_con_derecho"
              label="Días con Derecho"
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="dias_disfrutados"
              label="Días Disfrutados"
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="dias_pendientes"
              label="Días Pendientes"
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Table
        cols={columns}
        data={data}
        permission={getPermission}
        allowExportPDF={false}
      />
    </>
  );
};

export default ExpedienteVacaciones;
